var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footerpart",attrs:{"app":"","color":"white","inset":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear()))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }